import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { images } from 'src/app/resources/images';
import { AnomalyFormComponent } from '../anomaly-form/anomaly-form.component';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { NotificationService } from '@progress/kendo-angular-notification';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { Anomaly } from 'src/app/models/anomaly.model';


@Component({
    selector: 'app-anomaly-component',
    templateUrl: './anomaly-component.html'
})

export class AnomalyComponent implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public gridData: Anomaly[] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];
    public customMsgService: CustomMessagesService;
    public dataAnomaly: Anomaly[] = [];

    constructor(public msgService: MessageService,
        private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService,) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);
    }

    public load() {
        this.api
            .getRequest<BaseHttpResponse<Anomaly[]>>("Anomalia/GetAnomalias")
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
    }

    public ngOnInit(): void {
        this.gridView = this.gridData;
        this.load();
    }

    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;

        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: Anomaly) => {
        return `${args.codigo}_${args.traducoes[0].valor}_${args.traducoes[1].valor}_${args.traducoes[2].valor}`;
    }

/*     public photoURL(dataAnomaly: any): string {
        const code: string = dataAnomaly.imgId;
        const image: any = images;

        return image[code];
    }

    public flagURL(dataAnomaly: any): string {
        const code: string = dataAnomaly.country;
        const image: any = images;

        return image[code];
    } */

    //permições de utilizador
    canList() {
        return User.canAnomaliasList();
    }

    canCreate() {
        return User.canAnomaliasCreate();
    }

    canDelete() {
        return User.canAnomaliasDelete();
    }

    canEdit() {
        return User.canAnomaliasEdit();
    }


    public open(): void {

        const dialogRef: DialogRef = this.dialogService.open({
            title: this.customMsgService.translate('btnCriar') + " " + this.customMsgService.translate('anomalia'),
            content: AnomalyFormComponent,

        });

        const userInfo = dialogRef.content.instance as AnomalyFormComponent;
        dialogRef.result.subscribe((result) => {
            this.load();
        });

    }

    public delete(e: Anomaly): void {
        var sim = this.customMsgService.translate('yes');
        var nao = this.customMsgService.translate('no');
        const dialog: DialogRef = this.dialogService.open({
            appendTo: this.container,
            title: this.customMsgService.translate('confirmacao'),
            content: this.customMsgService.translate('desejaRemover'),
            actions: [{ text: nao }, { text: sim, themeColor: "primary" }],
            width: 450,
            height: 200,
            minWidth: 250,
        });
        dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
            } else if (result.text == sim) {
                this.api.cruddelete<BaseHttpResult>('Anomalia', e.id).
                    then(res => {
                        if (res.ok) {
                            this.notificationService.show({
                                appendTo: this.container,
                                content: this.customMsgService.translate('registoApagadoComSucesso'),
                                animation: { type: 'slide', duration: 500 },
                                position: { horizontal: 'center', vertical: 'top' },
                                type: { style: 'success', icon: true },
                                hideAfter: 2000
                            });
                            this.load();
                        }
                        else {
                            this.notificationService.show({
                                appendTo: this.container,
                                content: res.message,
                                animation: { type: 'slide', duration: 500 },
                                position: { horizontal: 'center', vertical: 'top' },
                                type: { style: 'error', icon: true },
                                hideAfter: 4000
                            });
                        }
                    }).
                    catch(err => {
                    });
            }
        });
    }


    public openEdit(c: Anomaly): void {
        const dialogRef: DialogRef = this.dialogService.open({
            title: this.customMsgService.translate('btnEditar') + " " + this.customMsgService.translate('anomalia'),
            content: AnomalyFormComponent
        });
        const userInfo = dialogRef.content.instance as AnomalyFormComponent;
        userInfo.formValue = c;
        userInfo.setFormValues();
        dialogRef.result.subscribe((result) => {
            this.load();
        });
    }

    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: process(this.gridView, { filter: this.filter }).data,
        };
        return result;
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.gridView, filter);
    }

}
